import React, { FC, useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';

import { useSetFilterParams } from '../../../../../../graphql/ecp-locator/actions/set-filter-params';
import {
  filterParamsExternal,
  setEcpFormSubmitted,
} from '../../../../../../graphql/ecp-locator/ecp-locator.cache';
import { useMyLocation } from '../../../../../../hooks/use-my-location';
import { useUpdateEcpStores } from '../../hooks/use-update-ecp-stores';
import { IFittingProps } from '../ecp-locator-settings.models';

export const withDefaultFiltersAndStoresList = <T extends unknown>(Component: FC<T>) => (
  props: T & IFittingProps,
): JSX.Element => {
  const { isLocationDefined, coords } = useMyLocation();
  const { setFilterParamsToCacheExternal } = useSetFilterParams();
  const [initLocationValue, setInitLocationValue] = useState(isLocationDefined);
  const { updateStores, isStoresLoading, isStoresError } = useUpdateEcpStores();
  const currentFilters = useReactiveVar(filterParamsExternal);

  useEffect(() => {
    const isLocationAllowedClick = isLocationDefined && !initLocationValue;
    const isLocationDeniedByUser = !isLocationDefined && initLocationValue;

    const filters = {
      ...currentFilters,
    };
    if (isLocationDefined) {
      updateStores({ filters, userLocation: coords });
      // Set value to notify error watcher if error should be shown.
      setEcpFormSubmitted(true);
    } else {
      setFilterParamsToCacheExternal(filters);
    }

    // set stores if user click allow button on location browser popup
    if (isLocationAllowedClick) {
      updateStores({ userLocation: coords });
      setInitLocationValue(true);
      // Set value to notify error watcher if error should be shown.
      setEcpFormSubmitted(true);
    }

    // set default state if user deny location access in browser
    if (isLocationDeniedByUser) {
      setInitLocationValue(false);
    }
  }, [isLocationDefined]);

  return (
    <Component
      {...props}
      isLoading={isStoresLoading}
      isError={isStoresError}
      updateStores={updateStores}
    />
  );
};
